import { IValidationRule } from "@/types"

const deliveryTermValidationRules: { [s: string]: IValidationRule } = {
    termId: {
        required: true,
    },
}

export default deliveryTermValidationRules
